import { PageController } from '@client/components/_core/layout/PageController';
import { DocumentLibrary } from '@client/components/_shared/documents/DocumentLibrary';
import { createFileRoute } from '@tanstack/react-router';
import { useCanEditMsprProvider } from '../hooks';

export const Route = createFileRoute('/console/$orgId/mspr/service-providers/details/$id/library')({
    component: Library,
    staticData: {
        ui: {
            useParentTitle: true,
        },
    },
});

function Library() {
    const canEdit = useCanEditMsprProvider();
    const { id } = Route.useParams();

    return (
        <PageController route={Route}>
            <DocumentLibrary entity="msprProvider" entityId={id} readOnly={!canEdit} shouldIncludeRelatedEntities />
        </PageController>
    );
}
